import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Person} from '../../models/policy.model';
import {GlobalQuestionService} from '../../services/global-question.service';

declare const $: any;

@Component({
    selector: 'app-request-call',
    templateUrl: './request-call.component.html',
    styleUrls: ['./request-call.component.scss'],
    standalone: false
})
export class RequestCallComponent implements OnInit {

  contactForm: FormGroup;
  person: Person;
  formSubmitted = false;
  buttonDisabled = false;
  maxCharacters = 1000;
  numberCharacters = 1000;

  constructor(private fb: FormBuilder, private questionService: GlobalQuestionService) {
  }

  ngOnInit(): void {
    this.contactForm = this.fb.group({
      name: [this.person?.first_name, Validators.required],
      contactNumber: ['', Validators.required],
      email: ['', Validators.required],
      message: ['', Validators.compose([Validators.required, Validators.maxLength(1000)])]
    });
  }

  showModal(person: Person): void {
    
    if (person) {
      this.person = person;
      this.contactForm.get('name').setValue(`${this.person?.first_name} ${this.person?.last_name}`);
      this.contactForm.get('contactNumber').setValue(this.person?.person_tel || this.person?.mobile);
      this.contactForm.get('email').setValue(this.person?.person_email || this.person?.email);
    }
    // $('#call-us__modal').modal('show');
    $('.modal').modal('hide');
    setTimeout(() => $('#call-us__modal').modal('show'), 300); // small delay to let previous modals close

  }

  submitPleaseCallMe(): void {
    this.formSubmitted = true;

    if (this.contactForm.valid) {
      this.buttonDisabled = true;
      this.questionService.spinner(true);
      const parameters = new Map<string, string>();
      parameters.set('full_name', this.contactForm.get('name')?.value);
      parameters.set('mobile', this.contactForm.get('contactNumber')?.value);
      parameters.set('email', this.contactForm.get('email')?.value);
      parameters.set('comment', this.contactForm.get('message')?.value);
      parameters.set('person_id', this.person?.person_id.toString());
      this.questionService.runCommandNew(`sendPleaseCallMe`, parameters)
        .subscribe(() => {
          this.buttonDisabled = false;
          this.formSubmitted = false;
          this.contactForm.reset();
          this.questionService.spinner(false);
          $('#call-us__modal').modal('hide');
        });
    }
  }

}
